import React, { FC, useEffect, useState } from "react";
import { Select, Space, Spin } from 'antd';
import { SelectProps } from 'antd/es/select';
import debounce from 'lodash/debounce';
import ServiceChannels from 'services/ServiceChannels';


export interface DebounceSelectProps<ValueType = any>
  extends Omit<SelectProps<ValueType>, 'options' | 'children'> {
  fetchOptions: (search: string) => Promise<ValueType[]>;
  debounceTimeout?: number;
}

function DebounceSelect<
  ValueType extends { key?: string; label: React.ReactNode; value: string | number } = any
>({ fetchOptions, debounceTimeout = 800, ...props }: DebounceSelectProps) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState<ValueType[]>([]);
  const fetchRef = React.useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);

      fetchOptions(value).then(newOptions => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }

        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout, { leading: true });
  }, [fetchOptions, debounceTimeout]);

  return (
    <Select<ValueType>
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      loading={fetching}
      {...props}
      options={options}
    />
  );
}

// Usage of DebounceSelect
interface selectValue {
  label: string;
  value: string;
}

async function fetchUserList(search: string): Promise<selectValue[]> {
  console.log('fetching user', search);
  if (search.length > 0) {
    return ServiceChannels.searchTags(search).then(tags => tagsArrayToOptions(tags));
  } else {

    return []
  }

}

const tagsArrayToOptions = (tags: string[]) => {

  if (!tags.length) return [];
  else {

    return tags.map(tag => ({ label: `${tag.trim()}`, value: tag.trim() }))
  }

}

interface ChannelTagsProps {
  onChangeTags: (tags: string[]) => void,
  tags: string[],
  isMyPage: boolean
}
const ChannelTags: FC<ChannelTagsProps> = ({ isMyPage, onChangeTags, tags = [] }) => {

  const [currentTags, setTags] = React.useState<selectValue[]>(tagsArrayToOptions(tags));

  const internalSetTags = (tags: selectValue[]) => {
    const filtered = tags.filter(tag => tag.value.length > 0).map(tag => {
      tag.value.trim();
      return tag;
    });
    onChangeTags(filtered.map(tag => tag.value))
    setTags(filtered)
  }
  return (<div className="channelTags">

    {
      !isMyPage ? <Space className="tags">{tags.map(tag => <span>{`${tag.trim()}`}</span>)}</Space>
        :

        <DebounceSelect
          mode="tags"
          value={currentTags}
          placeholder="Add hashtags"
          fetchOptions={fetchUserList}
          className="channelTagsSelect editable"
          tokenSeparators={[',']}
          maxTagCount="responsive"
          onChange={tags => {
            internalSetTags(tags)
          }}

        />
    }

  </div>)

}
export default ChannelTags
